import React, { useEffect, useRef } from 'react';
import { CheckIcon } from 'lucide-react';
interface Shop {
  id: string;
  name: string;
  logo: string;
  color: string;
  newOrders: number;
}
interface ShopSwitcherProps {
  shops: Shop[];
  selectedShop: Shop;
  onSelect: (shop: Shop) => void;
  onClose: () => void;
}
export function ShopSwitcher({
  shops,
  selectedShop,
  onSelect,
  onClose
}: ShopSwitcherProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);
  return <div className="absolute top-full right-0 mt-2 w-72 bg-white rounded-md shadow-lg z-50 border border-gray-200" ref={modalRef} data-id="element-1450">
      <div className="p-4 border-b border-gray-200" data-id="element-1451">
        <h3 className="text-lg font-medium text-gray-900" data-id="element-1452">Select shop</h3>
      </div>
      <div className="max-h-80 overflow-y-auto" data-id="element-1453">
        {shops.map(shop => <div key={shop.id} className="p-4 hover:bg-gray-50 cursor-pointer flex items-center justify-between border-b border-gray-100" onClick={() => onSelect(shop)} data-id="element-1454">
            <div className="flex items-center" data-id="element-1455">
              <div className="w-10 h-10 rounded-full flex items-center justify-center mr-3" style={{
            backgroundColor: shop.color
          }} data-id="element-1456">
                <span className="text-red-600" data-id="element-1457">{shop.logo}</span>
              </div>
              <div data-id="element-1458">
                <p className="font-medium text-gray-900" data-id="element-1459">{shop.name}</p>
                <div className="text-sm text-gray-500 bg-gray-200 px-2 py-0.5 rounded mt-1" data-id="element-1460">
                  {shop.newOrders} New orders
                </div>
              </div>
            </div>
            {selectedShop.id === shop.id && <div className="flex-shrink-0 text-blue-600" data-id="element-1461">
                <CheckIcon size={20} data-id="element-1462" />
              </div>}
          </div>)}
      </div>
    </div>;
}